import React, { useState } from 'react';
import { Modal } from 'react-bootstrap'
import './FloorPlanModal.scss'

const FloorPlanModal = (props) => {
    const [show, setShow] = useState(false);

    const handleClose = () => setShow(false);
    const handleShow = () => setShow(true);

    return (
        <>
            <a href="javascript:void(0)" onClick={handleShow}>
                Floorplans
            </a>

            <Modal
                show={show}
                onHide={handleClose}
                backdrop="static"
                keyboard={true}
                centered
                size="lg"
                dialogClassName="floorplan-large-modal"
                className="floorplan_modal"
            >
                <Modal.Header closeButton>
                </Modal.Header>
                <Modal.Body className="text-center">
                    
                    {props.floorplanimg.map(floorplanimg => (
                        (floorplanimg?.hd_url?.length > 0)
                            ? (<p><img src={floorplanimg?.hd_url} className="img-fluid m-0 modal-img" /></p>) :
                        (floorplanimg?.url?.length > 0 && !floorplanimg?.url?.includes(".pdf"))
                            ? (<p><img src={floorplanimg.url} className="img-fluid m-0 modal-img" /></p>)
                            : (floorplanimg?.srcUrl?.length > 0 && floorplanimg?.srcUrl?.includes(".pdf")) || (floorplanimg?.srcUrl?.length > 0 && floorplanimg[0]?.srcUrl?.includes(".pdf")) ?
                            
                                <iframe src={floorplanimg?.srcUrl || floorplanimg[0]?.srcUrl} width="100%" height="500px"></iframe>
                                : null

                    ))}
                </Modal.Body>
            </Modal>
        </>
    );
}

export default FloorPlanModal;